export default __webpack_public_path__ + "static/media/booktitle_thumb.82d1a752.png";